module.exports = __webpack_public_path__ + "img/collection-memoireRingsGrowingMemoires.ac06ec0.webp";